/* Snooflee: winkelwagen zonder herladen, paneel, scroll-animaties en slimme koopknoppen. */
(function () {
  'use strict';
  document.documentElement.classList.add('snf-js');

  var money = function (c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); };
  var drawer;
  function t(name, fallback) {
    return (drawer && drawer.dataset && drawer.dataset[name]) || fallback;
  }

  function initReveal() {
    var els = document.querySelectorAll('.snf-r, .snf-rz, .snf-stag');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('in'); });
    }, 50);
  }

  function initScrollUi() {
    var header = document.querySelector('.snf-hd');
    var sticky = document.querySelector('.snf-sticky');
    var anchor = document.querySelector('#kopen .snf-box') || document.querySelector('#kopen');
    if (!header && !sticky) return;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      if (header) header.classList.toggle('snf-stuck', y > 8);
      var past = anchor ? anchor.getBoundingClientRect().bottom < 40 : y > 600;
      if (header) header.classList.toggle('snf-past', past);
      if (sticky) sticky.classList.toggle('show', past);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    var ov = document.querySelector('[data-snf-overlay]');
    if (ov) ov.hidden = false;
    requestAnimationFrame(function () { document.documentElement.classList.add('snf-drawer-open'); });
    var c = drawer.querySelector('[data-snf-close]');
    if (c) c.focus();
  }
  function closeDrawer() {
    document.documentElement.classList.remove('snf-drawer-open');
    setTimeout(function () {
      if (drawer) drawer.hidden = true;
      var ov = document.querySelector('[data-snf-overlay]');
      if (ov) ov.hidden = true;
    }, 320);
  }

  function qtyControls(item) {
    return '<div class="snf-qty">' +
      '<button type="button" data-snf-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="' + t('tDown', 'Aantal verlagen') + '">−</button>' +
      '<span>' + item.quantity + '</span>' +
      '<button type="button" data-snf-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="' + t('tUp', 'Aantal verhogen') + '">+</button>' +
      '</div>';
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;
    document.querySelectorAll('[data-snf-count]').forEach(function (n) {
      var was = Number(n.textContent) || 0;
      n.textContent = count;
      n.classList.toggle('has', count > 0);
      if (count > was) { n.classList.remove('pulse'); void n.offsetWidth; n.classList.add('pulse'); }
    });
    if (!drawer) return;

    var list = drawer.querySelector('[data-snf-items]');
    var sub = drawer.querySelector('[data-snf-subtotal]');
    var empty = drawer.querySelector('[data-snf-empty]');
    var body = drawer.querySelector('[data-snf-body]');
    if (!list) return;

    list.innerHTML = '';
    if (count === 0) {
      if (empty) empty.hidden = false;
      if (body) body.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (body) body.hidden = false;

    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'snf-ci';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') + '" alt="" width="66" height="66">' : '';
      var vt = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      row.innerHTML = img +
        '<div class="snf-ci-m"><b>' + item.product_title + '</b><span>' + vt + '</span>' + qtyControls(item) + '</div>' +
        '<div class="snf-ci-p">' + money(item.final_line_price) + '</div>';
      list.appendChild(row);
    });

    if (sub) sub.textContent = money(cart.total_price);

    var up = drawer.querySelector('[data-snf-upsell]');
    if (up) {
      var upId = up.getAttribute('data-variant');
      var has = cart.items.some(function (i) { return String(i.variant_id) === String(upId); });
      up.hidden = has || !upId;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(id, qty, button) {
    if (button) { button.classList.add('is-loading'); button.disabled = true; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || t('tError', 'Toevoegen is niet gelukt.')); });
      return r.json();
    }).then(fetchCart).then(function () {
      if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      openDrawer();
    }).catch(function (err) {
      if (button) { button.classList.remove('is-loading'); button.disabled = false; }
      var msg = document.querySelector('[data-snf-error]');
      if (msg) { msg.textContent = err.message; msg.hidden = false; openDrawer(); }
      else window.location.href = '/cart';
    });
  }

  function init() {
    drawer = document.querySelector('[data-snf-drawer]');

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-snf-add]');
      if (!form) return;
      e.preventDefault();
      var checked = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!checked) return;
      addToCart(checked.value, 1, e.submitter || form.querySelector('button[type="submit"]'));
    });

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-snf-add-variant]');
      if (add) { e.preventDefault(); addToCart(add.getAttribute('data-snf-add-variant'), 1, add); return; }
      if (e.target.closest('[data-snf-open]')) { e.preventDefault(); fetchCart().then(openDrawer); return; }
      if (e.target.closest('[data-snf-close]') || e.target.closest('[data-snf-overlay]')) { e.preventDefault(); closeDrawer(); return; }
      var q = e.target.closest('[data-snf-qty]');
      if (q) { e.preventDefault(); changeQty(q.getAttribute('data-snf-qty'), Number(q.getAttribute('data-to'))); }
    });

    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-snf-locale]');
      if (sel && sel.form) sel.form.submit();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.documentElement.classList.contains('snf-drawer-open')) closeDrawer();
    });

    initReveal();
    initScrollUi();
    fetchCart();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
